import { createContext, useContext } from "react"

const PageContext = createContext({ tracking: { campaignID: "" }, seo: {} })

function useTrackingData() {
  const { tracking } = useContext(PageContext)
  return tracking
}

function useSEOData() {
  const { seo } = useContext(PageContext)
  return seo
}
const PageContextProvider = PageContext.Provider

export { PageContextProvider, useTrackingData, useSEOData }
